import {
    CANCEL_EWAY_BILL_REPORT_REQUEST,
    CANCEL_EWAY_BILL_REPORT_SUCCESS,
    CANCEL_EWAY_BILL_REPORT_FAILURE
  } from "../types/cancel-eway-bill-report-types.js";
  
  const initialState = {
    cancelEWayBillReports: {},
    loading: false,
    error: null,
  };
  
  const cancelEWayBillReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case CANCEL_EWAY_BILL_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case CANCEL_EWAY_BILL_REPORT_SUCCESS: {
        return {
          ...state,
          cancelEWayBillReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case CANCEL_EWAY_BILL_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default cancelEWayBillReportReducer;
  